export default "__VITE_ASSET__BTMrjts5__"